import * as React from "react";
import {
  Button as ShadcnButton,
  buttonVariants,
} from "@/components/shadcn/button";
import { cn } from "@/lib/utils";

// gunakan type, bukan interface kosong
export type UIButtonProps = React.ComponentProps<typeof ShadcnButton>;

export const UIButton = React.forwardRef<HTMLButtonElement, UIButtonProps>(
  ({ className, variant, ...props }, ref) => (
    <ShadcnButton
      ref={ref}
      className={cn(
        variant === "outline"
          ? "border border-white text-white bg-transparent hover:bg-white/10 hover:text-white"
          : "",
        variant === "default"
          ? "border border-white text-white bg-primary-700 hover:bg-primary-700/10 hover:text-white"
          : "",
        "cursor-pointer",
        className
      )}
      variant={variant}
      {...props}
    />
  )
);

UIButton.displayName = "UIButton";

export { buttonVariants };